<template>
    <div>
        <p class="pause-question" v-text="handlingForCountry"></p>
         <p v-if="isUSA" v-text="$t('FLOWERS_DELAY_TITLE')"></p>
        <form method="post" class="restart-dates">
            <div class="input__radio restart-date" v-for="(date, index) in this.availableRestartDates" :key="index">
                <input
                    class="input__radio-item"
                    :id="index"
                    v-model="selectedRestartDate"
                    type="radio"
                    :name="date.value"
                    :value="date.value"/>
                <label
                    :for="index"
                    class="input__radio-label restart-date--label"
                    v-text="date.label">
                </label>
            </div>
        </form>
        <button @click.prevent="pauseWithRestartDate" class="btn btn--primary btn--full-width restart-date--confirm">
            <span v-if="!processing" v-text="$t('PAUSE_DELIVERIES_RESTART_DATE_CONFIRM')"/>
            <i v-else class="btn__loading-icon fa-spin"/>
        </button>
        <button  v-text="handlingNextStepButton"
                @click.prevent="nextStep" class="btn btn--secondary btn--full-width restart-date--reject">
        </button>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ErrorResponseHandler from '@/helpers/ErrorResponseHandler';
import SubscriptionService from '@/services/subscriptions/SubscriptionService';
import { formatDisplayDateForRestartStep } from '@/helpers/DateHelpers';

let subscriptionService = new SubscriptionService();

export default {
    name: 'RestartStep',
    props: {
        subscriptionId: {
            required: true,
            type: Number,
        },
        pauseSurveyAnswer: {
            type: Object,
            required: true,
        },
        availableRestartDates: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            stageId: 'restart',
            isNextStepClicked: false,
            selectedRestartDate: null,
            errorHandler: new ErrorResponseHandler(),
            processing: false,
        };
    },
    computed: {
        ...mapGetters({
            isUSA: 'localisation/isUSA',
        }),
        updatedSteps() {
            const currentStepIndex = this.pauseSurveyAnswer.nextSteps.indexOf(this.stageId);
            return this.pauseSurveyAnswer.nextSteps.slice(currentStepIndex + 1);
        },
        getTitleForHouseRenovation() {
            if (this.pauseSurveyAnswer.id === 5) return this.$t('PAUSE_DELIVERIES_ANYTHING_BETTER_GOING_AWAY');
            else return this.$t('PAUSE_DELIVERIES_ANYTHING_BETTER_RENOVATING_HOUSE');
        },
        handlingForCountry() {
            return this.isUSA ? this.getTitleForHouseRenovation : this.$t('PAUSE_DELIVERIES_RESTART_DATE_QUESTION');
        },
        handlingNextStepButton() {
            return this.isUSA ? this.$t('PAUSE_DELIVERIES_NO_THANKS_RESTART') : this.$t('PAUSE_DELIVERIES_NO_THANKS');
        },
    },
    methods: {
        pauseWithRestartDate() {
            if (this.selectedRestartDate) {
                this.processing = true;
            }
            subscriptionService.pauseSubscription({ subscriptionId: this.subscriptionId, reason: this.pauseSurveyAnswer.label, feedback: null, resumeDate: this.selectedRestartDate })
                .then(() => {
                    this.$emit('deliveries-paused', this.pauseSurveyAnswer.id === 5 ? 'goingAway' : 'renovatingHouse');
                    this.processing = false;
                })
                .catch(error => this.errorHandler.setResponse(error.response.data));
        },

        closePauseDeliveries() {
            this.stage = 1;
            this.$emit('closed');
        },

        nextStep() {
            // this.isNextStepClicked = true;
            // this.$emit('input', this.updatedSteps);
            subscriptionService.pauseSubscription({ subscriptionId: this.subscriptionId, reason: this.pauseSurveyAnswer.label, feedback: null, resumeDate: null })
                .then(() => {
                    this.$emit('deliveries-paused');
                })
                .catch(error => this.errorHandler.setResponse(error.response.data));
        },

        getFormattedDate(date) {
            return formatDisplayDateForRestartStep(date);
        },
    },
};
</script>
<style lang="scss" scoped>
.pause-question {
    margin: 15px 0;
    text-align: left;
}
.restart-dates {
    margin-bottom: 20px;
}
.restart-date {
    margin: 8px 0;
}
.restart-date--label {
    font-size: 18px;
}
.restart-date--confirm {
    margin: 10px 0 0;
}
.restart-date--reject {
    margin: 10px 0 30px;
}
</style>
